import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useCallback,
} from "react";
import { apiAction } from "../axios";
import { PulseLoader } from "react-spinners";
import { APP_NAME, PUBLISHED_WEBSITE_DOMAIN } from "../app";
import { AccountContext } from "../account/account";
import { PLANS } from "../plans";
import { Helmet } from "react-helmet-async";

const WhiteLabelContext = createContext();

const SELF_DOMAINS = ["build.grigora.co", "localhost"];

const WhiteLabelProvider = (props) => {
  const [isWhitelabel, setIsWhitelabel] = useState(false);
  const [whitelabelSettings, setWhitelabelSettings] = useState(null);
  const [whitelabelDomain, setWhitelabelDomain] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isWhiteLabelOwner, setIsWhiteLabelOwner] = useState(false);
  const [whitelabelPlans, setWhitelabelPlans] = useState(PLANS);

  async function getDomainSettings(currentDomain) {
    setIsLoading(true);

    try {
      const response = await apiAction(
        "POST",
        "general/user/whitelabel/settings",
        {
          domain: currentDomain,
        },
      );

      if (response?.Output?.data) {
        setWhitelabelSettings(response?.Output?.data);
        setIsWhitelabel(true);
        setWhitelabelDomain(currentDomain);

        var newPlans = {};

        for (const plan of response?.Output?.data?.plans ?? []) {
          newPlans[plan?.planID] = plan;
        }

        // Add free plan for fallback
        newPlans["free"] = PLANS.free;

        setWhitelabelPlans(newPlans);
      }
    } catch (error) {
      console.error(error);
      // window.location.href = "https://" + SELF_DOMAINS?.[0];
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // Check the current domain
    const currentDomain = window.location.hostname;
    // const currentDomain = "whitelabel.latracal.com";

    if (!SELF_DOMAINS.includes(currentDomain)) {
      getDomainSettings(currentDomain);
    }
  }, []);

  const __whitelabel__ = (type, fallback) => {
    if (isWhitelabel) {
      return whitelabelSettings?.[type] || fallback;
    }

    return fallback;
  };

  const __whitelabel_website_publishing_domain__ = () => {
    if (isWhitelabel) {
      return "greatsite.app";
    }
    return PUBLISHED_WEBSITE_DOMAIN;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <PulseLoader color="#000" size={6} />
      </div>
    );
  }

  return (
    <>
      {!isWhitelabel && (
        <Helmet>
          <title>{`${__whitelabel__("platformName", APP_NAME)}`}</title>
        </Helmet>
      )}
      <WhiteLabelContext.Provider
        value={{
          isWhitelabel,
          whitelabelSettings,
          whitelabelDomain,
          isWhiteLabelOwner,
          setIsWhiteLabelOwner,
          __whitelabel__,
          __whitelabel_website_publishing_domain__,
          whitelabelPlans,
          setWhitelabelPlans,
        }}
      >
        {props.children}
      </WhiteLabelContext.Provider>
    </>
  );
};
export { WhiteLabelProvider, WhiteLabelContext };
